<template>
  <div v-if="error">
    Произошла ошибка. Обновите страницу.
  </div>
  <div v-else-if="!isLoad" class="mc-loader loader">
    <div class="mc-loader"><span class="mc-loader__circle"></span></div>
  </div>
  <component v-else :is="layout">
    <router-view/>
  </component>
</template>

<script>
import EmptyLayout from '@/layouts/EmptyLayout'
import MainLayout from '@/layouts/MainLayout'
import axios from 'axios'
import { firebaseService } from '@/services/firebase'
import { userService } from '@/services/user'
import { simulatedHoverMixin } from './mixin/simulatedHoverMixin'


export default {
  data: () => ({
    isLoad: false,
  }),
  mixins: [simulatedHoverMixin],
  computed: {
    layout() {
      return (this.$route.meta.layout || 'empty') + '-layout'
    },
    error() {
      return this.$store.getters.errorRequest
    }
  },

  components: {
    EmptyLayout,
    MainLayout
  },

  async created() {
    const { device_uuid, device } = this.$attrs
    this.device_uuid = device_uuid

    try {
      // Загрузка данных пользователя
      const response = await userService.register({ device, device_uuid })
      
      const userData = {
        ...response.data.data,
        device,
        uuid: device_uuid
      }
      // Устанавливаем данные пользователя в хранилище
      await this.$store.dispatch('Auth', userData)

      // Настройка интерсептора
      this.setupAxiosInterceptors()

      // Инициализация Firebase
      if (typeof window.FirebasePlugin !== 'undefined') {
        firebaseService.initializeMessageHandling(this.$store, this.$router)
      }
      
      // Проверяем, есть ли необходимость в редиректе по защите маршрутов
      this.checkRouteAccess()
      
    } catch (error) {
      console.error('Ошибка инициализации:', error)
    } finally {
      this.isLoad = true
    }
  },

  methods: {
    setupAxiosInterceptors() {
      this.axios.interceptors.response.use(
        response =>
        {
          if (response.data.status === 'error') {
            console.log(response.data.errors);
          }
          return response;
        },
        error => {
          if (error.response?.status === 401) {
            // Теперь можно включить редирект при ошибке авторизации
            this.$store.dispatch('logout')
            this.$router.push('/auth/')
          }
          if (error.response?.status === 500) {
            this.$router.push('/notfound')
          }
          return Promise.reject(error)
        }
      )
    },
    
    // Метод для проверки доступа к текущему маршруту после инициализации
    checkRouteAccess() {
      const currentRoute = this.$router.currentRoute.value
      // Проверяем доступ к защищенным маршрутам
      if (currentRoute.meta.requiresAuth === true && !this.$store.getters.isAuth) {
        this.$router.push('/auth/')
      } 
      // Проверяем доступ к маршрутам только для неавторизованных
      else if (currentRoute.meta.requiresAuth === false && this.$store.getters.isAuth) {
        this.$router.push('/')
      }
    }
  }
}
</script>

<style scoped>
.loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  text-align: center;
}

.spinner {
  height: 40px;
  border: 4px solid rgba(0, 0, 0, 0.2);
  border-radius: 50%;
  border-top-color: #ddd;
  animation: spiner 1s ease-in-out infinite;
  margin-bottom: 16px;
}



</style>